import xrmApiAnonymous from "src/services/xrmApi"
import { Product } from "src/states/shop/products"

export const fetchProducts = async () : Promise<Product[]> =>
  xrmApiAnonymous
    .get(`/product?exhibitionId=${process.env.NEXT_PUBLIC_WEBSHOP_XRM_EVENT_ID}`)
    .then(res => res?.data ?? [])
